<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>{{ modalTitle }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input v-if="itemSelected" container-class="mb-3" label="Utilisateur" :value="userName" disabled/>
            <c-input v-else type="autocomplete-input" container-class="mb-3" label="Utilisateur"
                     placeholder="Saisissez un nom..." :options="users"
                     @select="value => user = value" :state="userState">
              Veuillez sélectionner un utilisateur
            </c-input>
            <c-input container-class="mb-3" label="Nom du compte" placeholder="Ex: Campost Payment LTD"
                     v-model="account_name" :state="account_nameState" :disabled="!is_editable">
              Veuillez saisir un nom de compte
            </c-input>
            <c-input container-class="mb-3" type="select" label="Banque" :options="banks"
                     v-model="bank" :state="bankState" :disabled="!is_editable">
              <template slot="first">
                <option :value="null">-- Sélectionnez une banque --</option>
              </template>
              Veuillez sélectionner une banque
            </c-input>
            <template v-if="itemSelected">
              <c-input type="datetime" container-class="mb-3" label="Créé le" :value="created_at" disabled/>
              <c-input type="datetime" container-class="mb-3" label="Dernière modification" :value="updated_at" disabled/>
            </template>
          </d-col>
          <d-col class="ml-2">
            <b-form-group v-if="itemSelected">
              <label class="font-weight-bold mb-0">Fichier RIB</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="rib_filename" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <d-link class="btn btn-info" :href="rib_file_url" target="_blank">
                    <i class="fa fa-external-link-alt mr-1"></i> Ouvrir
                  </d-link>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
            <c-input v-else type="file" container-class="mb-3" label="Fichier RIB"
                     v-model="rib_file" :state="rib_fileState">
              Veuillez charger un fichier de RIB
            </c-input>
            <c-input container-class="mb-3" label="Code agence (ou guichet)" placeholder="Ex: 123456"
                     v-model="branch_code" :state="branch_codeState" :disabled="!is_editable">
              Veuillez saisir un code d'agence ou de guichet
            </c-input>
            <c-input container-class="mb-3" label="N° Compte" placeholder="Ex: 123456"
                     v-model="account_number" :state="account_numberState" :disabled="!is_editable">
              Veuillez saisir un numéro de compte
            </c-input>
            <c-input container-class="mb-3" label="Clé RIB" placeholder="Ex: 12"
                     v-model="rib_key" :state="rib_keyState" :disabled="!is_editable">
              Veuillez saisir une clé RIB (entre 00 et 99)
            </c-input>
            <c-input container-class="mb-3" label="Code SWIFT" placeholder="Ex: XXXXXX"
                     v-model="swift_code" :state="swift_codeState" :disabled="!is_editable">
              Veuillez saisir un code SWIFT
            </c-input>
            <d-form-checkbox v-model="is_operation_account" :disabled="!is_editable">
              Compte d'opération
            </d-form-checkbox>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner v-if="is_editable" variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-5 pb-0">
        <d-row>
          <d-col v-if="is_editable">
            <d-button class="inline-btn" @click="modalVisible = true">
              <i class="fa fa-plus mr-1"></i> Ajouter un compte bancaire
            </d-button>
          </d-col>
          <d-col cols="8">
            <d-input-group class="justify-content-end">
              <c-input class="w-25" placeholder="Utilisateur ou nom de compte ou banque..." v-model="search"/>
              <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetchingSearch"
                                @click="onSearchSubmit">
                <template slot="icon"><i class="fa fa-search"></i></template>
                Rechercher
              </c-button-spinner>
            </d-input-group>
          </d-col>
        </d-row>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="25">
          <p class="text-center" slot="empty">Aucun compte bancaire trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, Regex, Toast, truncate} from "@/helpers"

export default {
  title: "Gestion des comptes bancaires",
  data() {
    return {
      search: "",
      fetchingSearch: false,

      fetchingData: false,
      data: [],
      banks: [],
      users: [],

      //table header
      fields: [
        {key: "name_pretty", label: "Compte", sortable: true},
        {key: "user_name", label: "Utilisateur", sortable: true},
        {key: "iban", label: "IBAN", sortable: true},
        {key: "created_at_pretty", label: "Créé le", sortable: true},
        {key: "status", label: "Compte d'op. ?", sortable: true},
        {key: "actions", label: "Actions"},
      ],

      actions: [
        {type: "white", icon: "fa fa-ellipsis-h", title: "Détails du compte", handler: this.onItemSelect}
      ],

      modalVisible: false,
      selectedItem: null,

      submitted: false,
      fetchingFormSubmit: false,

      user: null,
      bank: null,
      account_name: "",
      rib_file: null,
      branch_code: "",
      account_number: "",
      rib_key: "",
      swift_code: "",
      is_operation_account: false,
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data
        .filter(item => {
          const user = item.user, bank = item.bank
          return item.name.toLowerCase().includes(search) || item.branch_code.toLowerCase().includes(search)
            || item.account_number.toLowerCase().includes(search) || item.swift_code.toLowerCase().includes(search)
            || (user.first_name + " " + user.last_name).toLowerCase().includes(search)
            || user.username.toLowerCase().includes(search)
            || bank.name.toLowerCase().includes(search) || bank.slug.toLowerCase().includes(search)
            || bank.code.toLowerCase().includes(search)
        })
    },
    itemSelected() {
      return !!this.selectedItem
    },
    is_editable() {
      return this.auth.isOpManager()
    },
    modalTitle() {
      return this.itemSelected ? "Détails du compte bancaire" : "Nouveau compte bancaire"
    },

    userName() {
      if (this.itemSelected) {
        return this.getUserName(this.selectedItem.user)
      }

      return ""
    },
    created_at() {
      return this.itemSelected ? this.selectedItem.created_at : ""
    },
    updated_at() {
      return this.itemSelected ? this.selectedItem.updated_at : ""
    },
    rib_file_url() {
      return this.itemSelected ? this.selectedItem.rib_file : ""
    },
    rib_filename() {
      return this.itemSelected ? this.selectedItem.rib_filename : ""
    },

    userState() {
      return !this.submitted || this.itemSelected || Regex.isNotEmpty(this.user)
    },
    bankState() {
      return !this.submitted || Regex.isNotEmpty(this.bank)
    },
    account_nameState() {
      return !this.submitted || Regex.isNotBlank(this.account_name)
    },
    rib_fileState() {
      return !this.submitted || this.itemSelected || Regex.isNotEmpty(this.rib_file)
    },
    branch_codeState() {
      return !this.submitted || Regex.isNotBlank(this.branch_code)
    },
    account_numberState() {
      return !this.submitted || Regex.isNotBlank(this.account_number)
    },
    rib_keyState() {
      return !this.submitted || (Regex.isPositiveInteger(this.rib_key) && this.rib_key.length === 2)
    },
    swift_codeState() {
      return !this.submitted || Regex.isNotBlank(this.swift_code)
    },
  },
  created() {
    this.fetchingData = true

    Api.get("/user/merchant/list")
      .then(res => this.users = res.data.users.map(this.mapUser))
      .catch(err => this.error = err)
      .then(() => null)

    Api.get("/bank/list")
      .then(res => this.banks = res.data.banks.map(this.mapBank))
      .catch(err => this.error = err)
      .then(() => null)

    Api.get("/bank/account/list")
      .then(res => this.data = res.data.bank_accounts.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    getUserName(user, maxLength = -1) {
      let name = user.first_name + " " + user.last_name
      if (maxLength > 0)
        name = truncate(name, maxLength)
      return name + (user.verified ? " ✔" : "")
    },
    mapUser(user) {
      return {
        text: this.getUserName(user),
        value: user.id
      }
    },
    mapBank(bank) {
      return {
        text: bank.name,
        value: bank.id
      }
    },
    mapItem(item) {
      const bank = item.bank
      return {
        ...item,
        name_pretty: item.name + `\n(${item.bank.name})`,
        user_name: this.getUserName(item.user, 20),
        iban: `${bank.country.slug}${item.iban_key} ${bank.code}-${item.branch_code}-${item.account_number}-${item.rib_key}`,
        created_at_pretty: item.created_at.replace(" ", "\n"),
        status: item.is_operation_account ? "Oui" : "Non",
        statusVariant: item.is_operation_account ? "success" : "secondary",
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.modalVisible = true

      this.account_name = item.name
      this.bank = item.bank.id
      this.branch_code = item.branch_code
      this.account_number = item.account_number
      this.rib_key = item.rib_key
      this.swift_code = item.swift_code
      this.is_operation_account = item.is_operation_account
    },
    clearFields() {
      this.user = null
      this.bank = null
      this.account_name = ""
      this.branch_code = ""
      this.account_number = ""
      this.rib_key = ""
      this.swift_code = ""
      this.is_operation_account = false
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearFields()
    },
    isFormValid() {
      return this.userState && this.bankState && this.account_nameState && this.rib_fileState && this.branch_codeState
        && this.account_numberState && this.rib_keyState && this.swift_codeState
    },
    onFormSubmit() {
      this.submitted = true
      if (!this.isFormValid()) return

      if (this.itemSelected)
        this.onBankAccountUpdate()
      else
        this.onBankAccountCreate()
    },
    onBankAccountCreate() {
      this.fetchingFormSubmit = true
      Api.postFormData("/bank/account/create", {
        user_id: this.user,
        name: this.account_name,
        bank_id: this.bank,
        rib_file: this.rib_file,
        branch_code: this.branch_code,
        account_number: this.account_number,
        rib_key: this.rib_key,
        swift_code: this.swift_code,
        is_operation_account: this.is_operation_account,
      })
        .then(res => {
          const bank_account = this.mapItem(res.data.bank_account)
          this.data.unshift(bank_account)

          this.onModalClose()

          Toast.success(`Le compte "${bank_account.name}" a été créé avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onBankAccountUpdate() {
      this.fetchingFormSubmit = true
      Api.postFormData("/bank/account/update", {
        bank_account_id: this.selectedItem.id,
        name: this.account_name,
        bank_id: this.bank,
        branch_code: this.branch_code,
        account_number: this.account_number,
        rib_key: this.rib_key,
        swift_code: this.swift_code,
        is_operation_account: this.is_operation_account,
      })
        .then(res => {
          const bank_account = this.mapItem(res.data.bank_account)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, bank_account)

          this.onModalClose()

          Toast.success(`Le compte "${bank_account.name}" a été mis à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onSearchSubmit() {
      this.fetchingSearch = true
      Api.postFormData("/bank/account/find", {search: this.search})
        .then(res => this.data = res.data.bank_accounts.map(this.mapItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
  }
}
</script>
